import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

Array.from(document.querySelectorAll('.pdf-viewer')).forEach(item => {
  console.log('src', item.getAttribute('data-src'));
  const root = ReactDOM.createRoot(item);
  root.render(
    <React.StrictMode>
      <App src={item.getAttribute('data-src')}/>
    </React.StrictMode>
  );
})
